import React, { Component } from 'react';
import { Container } from 'reactstrap';
//import { NavMenu } from './NavMenu';
//import { FormularioAlumni } from './Formulario';
//import { FormularioAlumniTabs } from './FormularioTabs';
//import { FormularioTabsNew } from './FormularioTabsNew';
//import { MiniFormulario } from './MiniFormulario';
//import { DownloadReport } from './DownloadReport';
//import { Aviso } from './Aviso';

export class Layout extends Component {
    static displayName = Layout.name;

    constructor(props) {
        super(props);
    }

  render () {
    return (
        <div>
            {/* DESCOMENTAR PARA PUBLICAR CON LA PANTALLA DE REPORTE */}
            <Container fluid>
                {this.props.children}
            </Container>

            {/*<div className="container-fluid">*/}
            {/*    <FormularioTabsNew />*/}
            {/*</div>*/}
      </div>
    );
  }
}
